function f(t, e) {
  function n(i) {
    const c = t.getBoundingClientRect(), d = t.ownerDocument.defaultView, u = c.left + d.scrollX, v = c.top + d.scrollY, l = i.pageX - u, r = i.pageY - v;
    e != null && e.onMove && e.onMove(l, r);
  }
  function o() {
    document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", o), e != null && e.onStop && e.onStop();
  }
  document.addEventListener("pointermove", n, { passive: !0 }), document.addEventListener("pointerup", o), (e == null ? void 0 : e.initialEvent) instanceof PointerEvent && n(e.initialEvent);
}
export {
  f as d
};
